const meansOfDeath = [
   {
      "game": 1,
      "kills_by_means": {
         "kill": 0
      },
   },
   {
      "game": 2,
      "kills_by_means": {
         "MOD_TRIGGER_HURT": 7,
         "MOD_ROCKET_SPLASH": 3,
         "MOD_FALLING": 1
      }
   },
   {
      "game": 3,
      "kills_by_means": {
         "MOD_TRIGGER_HURT": 2,
         "MOD_ROCKET": 1,
         "MOD_FALLING": 1
      }
   },
   {
      "game": 4,
      "kills_by_means": {
         "MOD_ROCKET_SPLASH": 51,
         "MOD_ROCKET": 20,
         "MOD_FALLING": 11,
         "MOD_TRIGGER_HURT": 9,
         "MOD_RAILGUN": 8,
         "MOD_MACHINEGUN": 4,
         "MOD_SHOTGUN": 2
      }
   },
   {
      "game": 5,
      "kills_by_means": {
         "MOD_TRIGGER_HURT": 5,
         "MOD_ROCKET": 4,
         "MOD_ROCKET_SPLASH": 4,
         "MOD_RAILGUN": 1
      }
   },
   {
      "game": 6,
      "kills_by_means": {
         "MOD_ROCKET_SPLASH": 13,
         "MOD_ROCKET": 5,
         "MOD_SHOTGUN": 4,
         "MOD_TRIGGER_HURT": 3,
         "MOD_RAILGUN": 2,
         "MOD_FALLING": 1,
         "MOD_MACHINEGUN": 1
      }
   },
   {
      "game": 7,
      "kills_by_means": {
         "MOD_ROCKET_SPLASH": 49,
         "MOD_ROCKET": 29,
         "MOD_TRIGGER_HURT": 20,
         "MOD_RAILGUN": 9,
         "MOD_MACHINEGUN": 9,
         "MOD_FALLING": 7,
         "MOD_SHOTGUN": 7
      }
   },
   {
      "game": 8,
      "kills_by_means": {
         "MOD_ROCKET_SPLASH": 39,
         "MOD_ROCKET": 18,
         "MOD_RAILGUN": 12,
         "MOD_TRIGGER_HURT": 9,
         "MOD_FALLING": 6,
         "MOD_MACHINEGUN": 4,
         "MOD_SHOTGUN": 1
      }
   },
   {
      "game": 9,
      "kills_by_means": {
         "MOD_ROCKET_SPLASH": 25,
         "MOD_ROCKET": 17,
         "MOD_RAILGUN": 10,
         "MOD_TRIGGER_HURT": 8,
         "MOD_MACHINEGUN": 3,
         "MOD_FALLING": 3,
         "MOD_SHOTGUN": 1
      }
   },
   {
      "game": 10,
      "kills_by_means": {
         "MOD_TELEFRAG": 25,
         "MOD_TRIGGER_HURT": 17,
         "MOD_RAILGUN": 7,
         "MOD_ROCKET": 4,
         "MOD_BFG_SPLASH": 2,
         "MOD_BFG": 2,
         "MOD_ROCKET_SPLASH": 1,
         "MOD_MACHINEGUN": 1,
         "MOD_CRUSH": 1
      }
   },
   {
      "game": 11,
      "kills_by_means": {
         "MOD_TRIGGER_HURT": 7,
         "MOD_ROCKET_SPLASH": 4,
         "MOD_RAILGUN": 4,
         "MOD_BFG_SPLASH": 3,
         "MOD_CRUSH": 1,
         "MOD_MACHINEGUN": 1
      }
   },
   {
      "game": 12,
      "kills_by_means": {
         "MOD_RAILGUN": 38,
         "MOD_TRIGGER_HURT": 37,
         "MOD_ROCKET_SPLASH": 35,
         "MOD_ROCKET": 25,
         "MOD_BFG_SPLASH": 8,
         "MOD_BFG": 8,
         "MOD_MACHINEGUN": 7,
         "MOD_FALLING": 2
      }
   },
   {
      "game": 13,
      "kills_by_means": {
         "MOD_TRIGGER_HURT": 2,
         "MOD_ROCKET": 1,
         "MOD_ROCKET_SPLASH": 1,
         "MOD_BFG_SPLASH": 1,
         "MOD_BFG": 1
      }
   },
   {
      "game": 14,
      "kills_by_means": {
         "MOD_TRIGGER_HURT": 31,
         "MOD_ROCKET_SPLASH": 24,
         "MOD_ROCKET": 23,
         "MOD_RAILGUN": 20,
         "MOD_BFG_SPLASH": 10,
         "MOD_FALLING": 5,
         "MOD_BFG": 5,
         "MOD_MACHINEGUN": 4
      }
   },
   {
      "game": 15,
      "kills_by_means": {
         "MOD_TRIGGER_HURT": 3
      }
   },
   {
      "game": 16,
      "kills_by_means": {
         "kill": 0
      }
   },
   {
      "game": 17,
      "kills_by_means": {
         "MOD_TRIGGER_HURT": 6,
         "MOD_FALLING": 3,
         "MOD_RAILGUN": 2,
         "MOD_ROCKET_SPLASH": 2
      }
   },
   {
      "game": 18,
      "kills_by_means": {
         "MOD_ROCKET_SPLASH": 4,
         "MOD_ROCKET": 1,
         "MOD_FALLING": 1,
         "MOD_TRIGGER_HURT": 1
      }
   },
   {
      "game": 19,
      "kills_by_means": {
         "MOD_ROCKET_SPLASH": 32,
         "MOD_ROCKET": 27,
         "MOD_TRIGGER_HURT": 12,
         "MOD_RAILGUN": 10,
         "MOD_MACHINEGUN": 7,
         "MOD_SHOTGUN": 6,
         "MOD_FALLING": 1
      }
   },
   {
      "game": 20,
      "kills_by_means": {
         "MOD_ROCKET_SPLASH": 2,
         "MOD_ROCKET": 1
      }
   },
   {
      "game": 21,
      "kills_by_means": {
         "MOD_ROCKET_SPLASH": 60,
         "MOD_ROCKET": 37,
         "MOD_TRIGGER_HURT": 14,
         "MOD_RAILGUN": 9,
         "MOD_MACHINEGUN": 4,
         "MOD_SHOTGUN": 4,
         "MOD_FALLING": 3
      }
   }
]

export default meansOfDeath;
